//Default Log Template to initialize editable items when creating a new entity in the editor
//Frozen so this default can't be changed by users.
export const defaultItem_LogTemplate = Object.freeze({
    label: 'New Log Template',
    title: 'New Log Template',
    sections: [],
    params: [],
    _tagIds: [],
    _variableIds: [],
    _logTemplateIds: [],
});
//# sourceMappingURL=consts.js.map